import * as service from './service'
export default {
  namespace: 'shansongStudyStudyLimitTask',
  state: {
    taskData: []
  },
  effects: {
    * getList ({ payload }, { call, put }) {
      const res = yield call(service.getList, payload)
      yield put({
        type: 'save',
        payload: {
          taskData: res.data.data
        }
      })
      return res.data
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
